import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { ApolloLink } from 'apollo-link';
import { RetryLink } from 'apollo-link-retry';
import { InMemoryCache } from 'apollo-cache-inmemory';

// I know its not a hook, but wanted it next to usePersistentClient
var useDormifyGateway = function useDormifyGateway() {
  var httpLink = createHttpLink({
    uri: 'https://dormify-gateway-33tdfxk4ua-ue.a.run.app/graphql'
  });

  var retryLink = new RetryLink();

  var cache = new InMemoryCache({
    dataIdFromObject: function dataIdFromObject(object) {
      switch (object.__typename) {
        case 'Product':
          return object['variantId']; // use `variantId` as the primary key

        default:
          return false; // fall back to `id` and `_id` for all other types
      }
    }
  });

  return new ApolloClient({
    link: ApolloLink.from([retryLink, httpLink]),
    cache: cache,
    fetchOptions: {
      mode: 'no-cors'
    }
  });
};

export default useDormifyGateway;